module.exports = __webpack_public_path__ + "img/pp-logo-white.3eba1823.svg";